import useReactHookForm from "hooks/useReactHookForm";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { useEffect } from "react";
import {
  courseFilterInitialValues,
  courseFilterProperties,
  courseFilterValidationSchema,
  hasAtLeastOneValue,
} from "./helper";
import { hasValidValue } from "pages/entities/helper";
import { isEmpty } from "utils/helpers";
import { set } from "react-hook-form";

type CourseFilterProps = {
  onSearch: (values: any) => void;
  onClear: () => void;
  setPage: (page: number) => void;
  clearValuesTrigger?: any;
};

export default function CourseFilter({
  onSearch,
  onClear,
  clearValuesTrigger,
  setPage
}: CourseFilterProps) {
  const { control, getValues, watch, setValue } = useReactHookForm(
    courseFilterInitialValues,
    courseFilterValidationSchema,
    ""
  );

  const clearFilter = () => {
    setValue("course_name", "");
    setValue("status", "");
    onClear();
    setPage(1);
  };

  const handleSearch = () => {
    const payload = {
      course_name: watch()?.course_name,

    };
      if(!isEmpty(watch()?.status)){
      payload["status"]= watch()?.status
    }
    onSearch(payload);
    setPage(1);
  };

  useEffect(() => {
    clearFilter();
  }, [clearValuesTrigger]);

  return (
    <Paper elevation={2} sx={{ px: 2, pb: 2, mb: 2 }}>
      <Grid container spacing={2}>
        <DynamicForm
          fields={courseFilterProperties}
          control={control}
          getValues={getValues}
          setValue={setValue}
          watch={watch}
          errors={{}}
        />
        <ContentRight sx={{ mt: -7 }}>
          <Button
            variant="contained"
            sx={{ mr: 1 }}
            onClick={clearFilter}
            disabled={!hasAtLeastOneValue(watch(),["status","course_name"])}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            onClick={handleSearch}
            disabled={!hasAtLeastOneValue(watch(),["status","course_name"])}
          >
            Search
          </Button>
        </ContentRight>
      </Grid>
    </Paper>
  );
}
